import * as React from 'react';

export type WithCompanyId = {
  id: string;
};

export const CompanyIdContext = React.createContext<WithCompanyId | null>(null);
